import Vue from 'vue';
import Router from 'vue-router';

import store from '../store/index'
import auth from '../auth/index'

// Components
import Ideas from '@/components/Ideas';
import IdeaPage from '@/components/IdeaPage';
import IdeaCreate from '@/components/IdeaCreate';
import IdeaEdit from '@/components/IdeaEdit';
import SearchPage from '@/components/SearchPage';
import Thanks from '@/components/Thanks';
import Login from '@/components/Login';

Vue.use(Router);

const router = new Router({
    linkActiveClass: 'active',
    mode: 'history',
    routes: [
        {
            name: 'ideas',
            path: '/ideas/',
            component: Ideas
        },
        {
            name: 'ideas-category',
            path: '/ideas/category/:category_id(\\d+)',
            meta: { scroll: true },
            component: Ideas
        },
        {
            name: 'my-ideas',
            path: '/ideas/my/',
            component: Ideas,
            meta: { filter: 'my' },
            beforeEnter: (to, from, next) => {
                store.dispatch('auth/isLogged')
                    .then(isLogged => {
                        if (!isLogged) {
                            return next({
                                name: 'login',
                                query: { redirect: to.fullPath }
                            })
                        }
                        next();
                    });
            }
        },
        {
            name: 'inprocess-ideas',
            path: '/ideas/inprocess/',
            component: Ideas,
            meta: { filter: 'inprocess' }
        },
        {
            name: 'completed-ideas',
            path: '/ideas/completed/',
            component: Ideas,
            meta: { filter: 'completed' }
        },
        {
            name: 'moderation-ideas',
            path: '/ideas/moderation/',
            component: Ideas,
            meta: { filter: 'moderation' }
        },
        {
            name: 'canceled-ideas',
            path: '/ideas/canceled/',
            component: Ideas,
            meta: { filter: 'canceled' }
        },
        {
            name: 'starred-ideas',
            path: '/ideas/starred/',
            component: Ideas,
            meta: { filter: 'starred' },
            beforeEnter: (to, from, next) => {
                store.dispatch('auth/isLogged')
                    .then(isLogged => {
                        if (!isLogged) {
                            return next({
                                name: 'login',
                                query: { redirect: to.fullPath }
                            })
                        }
                        next();
                    });
            }
        },
        {
            name: 'idea-create',
            path: '/ideas/create',
            component: IdeaCreate,
            meta: { scroll: true }
        },
        {
            name: 'thanks',
            path: '/ideas/thanks',
            component: Thanks
        },
        {
            name: 'idea',
            path: '/ideas/:id(\\d+)',
            component: IdeaPage,
            meta: { scroll: true }
        },
        {
            name: 'idea-edit',
            path: '/ideas/edit/:id(\\d+)',
            component: IdeaEdit,
            meta: { scroll: true }
        },
        {
            name: 'search',
            path: '/ideas/search/:term',
            component: SearchPage,
            meta: { scroll: true }
        },
        {
            name: 'login',
            path: '/ideas/login',
            component: Login
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (to.meta.scroll) {
            return { x: 0, y: 0 }
        }
    }
});

router.beforeEach((to, from, next) => {
    store.dispatch('toggleSearch', false);

    if (from.params.id !== to.params.id) {
        store.dispatch('ideas/setCurrentIdeaId', null)
    }

    store.dispatch('auth/isLogged');

    if (0 && to.matched.some(record => !(record.name == 'login'))) {

        // этот путь требует авторизации, проверяем залогинен ли
        // пользователь, и если нет, перенаправляем на страницу логина
        store.dispatch('auth/isLogged').then(isLogged => {
            if (!isLogged) {
                next({
                    name: 'login',
                    query: { redirect: to.fullPath }
                })
            } else {
                let forbidden = to.matched.filter(route => {
                    return route.meta.permission && !auth.canI(route.meta.permission)
                })
                if (forbidden.length > 0) {
                    next({
                        name: 'login',
                        query: {
                            message: 'Доступ запрещен',
                            redirect: to.fullPath
                        }
                    })
                }

                if (store.state.ideas.categories.length === 0) {
                    store.dispatch('ideas/loadCategories').then(() => {
                        next();
                    })
                } else {
                    next();
                }
            }
        })
    } else {
        if (store.state.ideas.categories.length === 0) {
            store.dispatch('ideas/loadCategories').then(() => {
                next();
            })
        } else {
            next();
        }
    }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js